let PopComponent = {};

PopComponent['ErrorPop'] = require('../PopContent/ErrorPop').default;

export default PopComponent